module.exports = __webpack_public_path__ + "materialdesignicons-webfont.3bd364e5b4f5c3e57a73.eot";


//////////////////
// WEBPACK FOOTER
// /Users/dendy.anggaditya/Documents/bitbucket/invisee-front-end-jtrust-widget/src/assets/fonts/materialdesignicons-webfont.eot
// module id = ../../../../../src/assets/fonts/materialdesignicons-webfont.eot
// module chunks = styles